<template>
    <img :src="require('@/assets/images/logo.svg')" v-if="this.$public.isCordova()" alt="享樂遊"/>
    <div v-else class="hasText">
        <img :src="require('@/assets/images/logo_s.svg')" alt="享樂遊" class="tw">
        <i class="el-icon-close" v-if="path!==''"/>
        <img :src="path" :alt="showName" v-if="path!==''">
        <h1>{{showName}}</h1>
    </div>
</template>

<script>
    import {setShopAreaInfo} from "../store/mutationTypes";

    export default {
        name: "Logo",
        data() {
            return {
                showName: this.$store.state.shopAreaInfo.name,
                path: this.$store.state.shopAreaInfo.logoPath,
                removeSubscribe: {},
            }
        },
        beforeCreate() {
        },
        created() {
        },
        mounted() {
            let self = this;
            self.removeSubscribe = self.$store.subscribe((mutation, state) => {
                if (mutation.type === "updateShopAreaInfo") {
                    let shopAreaInfo = state.shopAreaInfo;
                    self.showName = shopAreaInfo.name;
                    self.path = shopAreaInfo.logoPath;
                }
            });
        },
        methods: {},
        watch: {
        },
    }
</script>
